module.exports = __webpack_public_path__ + "static/pixel-pride-logo-fb43351c9407e0b8e72395ad31906f23.jpg";